import { FC, ReactNode } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  label: ReactNode;
  value: ReactNode;
  className?: string;
  valueClassName?: string;
};

/**
 * Компактный блок статистики: подпись сверху, значение снизу.
 * Используется в детальных карточках и мини-отчёте консультанта.
 */
export const StatBox: FC<Props> = ({ label, value, className, valueClassName }) => (
  <div className={cn('border rounded-lg p-3', className)}>
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className={cn('text-2xl font-bold', valueClassName)}>{value}</div>
  </div>
);
